import React from 'react';
import { Loader2 } from 'lucide-react';

interface SecretUpdateModalProps {
  isOpen: boolean;
  title: string;
  fieldLabel: string;
  saving: boolean;
  onClose: () => void;
  onSave: (value: string) => void;
}

export const SecretUpdateModal: React.FC<SecretUpdateModalProps> = ({ isOpen, title, fieldLabel, saving, onClose, onSave }) => {
  const [value, setValue] = React.useState('');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4">
      <div className="w-full max-w-md rounded-2xl border border-strivre-lightnavy bg-white p-6 shadow-xl">
        <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
        <p className="mt-2 text-sm text-slate-500">Enter a new value to update this secret.</p>

        <div className="mt-4 space-y-2">
          <label className="text-sm font-semibold text-slate-700">{fieldLabel}</label>
          <input
            type="password"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="w-full rounded-xl border border-strivre-lightnavy text-slate-900 px-4 py-2.5 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10"
            placeholder="Enter value"
          />
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button onClick={onClose} className="rounded-xl border border-strivre-lightnavy px-4 py-2 text-sm font-semibold text-slate-600">
            Cancel
          </button>
          <button
            onClick={() => onSave(value)}
            disabled={saving || !value.trim()}
            className="flex items-center gap-2 rounded-xl bg-strivre-burgundy px-4 py-2 text-sm font-semibold text-white disabled:bg-red-800"
          >
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
